import { connect } from 'react-redux';

import { Dispatch } from '../../../../../../common/state';
import { ClearFiltersButton as ClearFiltersButtonComponent, IClearFiltersButtonProps } from './ClearFiltersButton';

type TClearFiltersButtonDispatchProps = Pick<IClearFiltersButtonProps, 'onClick'>;

export function mapDispatchToProps(dispatch: Dispatch): TClearFiltersButtonDispatchProps {
  return {
    onClick: () => {
      dispatch({
        type: 'filters/tags/ALL_TAGS_REMOVED',
      });
    },
  };
}

export const ClearFiltersButton = connect(null, mapDispatchToProps)(ClearFiltersButtonComponent);
